#@import moment
#@export GliveBooking.Models.Time

class GliveBooking.Models.Time extends BookingV2.Models.Base

  constructor: ->
    BookingV2.Models.Base.apply this, arguments
    initialTimeMoment = moment(@get('initial_time'))
    finalTimeMoment = moment(@get('initial_time'))

    @set
      initialTimeMoment: initialTimeMoment
      finalTimeMoment: finalTimeMoment
      clndrTimeMoment: initialTimeMoment

  start: ->
    @get('initialTimeMoment')

  end: ->
    @get('initialTimeMoment')
